<shrd-pf-ui-meta-nav-item *shrdUtcLet="cartAmount$ | async as amount">
  <a
    [href]="cartUrl"
    shrdUicButton
    [variant]="btnVariant"
    [ngClass]="btnClasses"
    [shrdUtcCountIndicator]="amount"
    indicatorVariant="primary"
    [scaleIn]="true"
    class="meta-nav-item"
    
    [shrdUtcTrackEvent]="{ category: 'SiteOperations', action: 'MainNavigation', label: trackingName }"
  >
    <span shrdPfUiMaxWidth class="visually-hidden-sm-down no-truncate">{{ title }}</span>
    <shrd-uic-svg-icon
      [inheritColor]="true"
      [icon]="amount ? iconsName.CART_FULL : iconsName.CART_EMPTY"
    ></shrd-uic-svg-icon>
  </a>
</shrd-pf-ui-meta-nav-item>
